import MainConnection from "./MainConnection";
import AlertManager from "../utils/AlertManager";

export default {
  requestCategoryList: async function() {
    try {
      const requestURL = "/categories";
      const response = await MainConnection.request().get(requestURL);

      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestCreateCategory: async function(params) {
    try {
      const requestURL = "/categories";
      const response = await MainConnection.request().post(requestURL, params);

      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestUpdateCategory: async function(category_id, params) {
    try {
      const requestURL = "/categories/" + category_id;
      const response = await MainConnection.request().patch(requestURL, params);

      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  removeCategoryById: async function(category_id) {
    try {
      const requestURL = "/categories/" + category_id;
      const response = await MainConnection.request().delete(requestURL);

      switch (response.data.code) {
        case "0":
          return true;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          return false;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
